import { gql } from "@apollo/client";

const CMS = gql`
  query getPublicCMS($input: GetCMS!) {
    getPublicCMS(input: $input) {
      status
      error
      data {
        commonContent
        pageContent
      }
    }
  }
`;

export default CMS;
